if (!customElements.get('discount-code')) {
  class DiscountCode extends HTMLElement {
    constructor() {
      super();
      this.discountCode = this.querySelector('.js-discount-code');
      this.discountCodeBtn = this.querySelector('.js-copy-button');
      this.copySuccess = this.querySelector('.js-copy-success');
      this.originalButtonHTML = this.discountCodeBtn?.innerHTML;
      this.init();
    }

    init() {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        this.discountCodeBtn.addEventListener('click', this.copyCode.bind(this));
        this.discountCode.addEventListener('click', this.copyCode.bind(this));
      } else {
        this.discountCodeBtn.hidden = true;
      }
    }

    copyCode() {
      // Fallback: Check if required elements exist
      if (!this.discountCode) {
        console.warn('Discount code element not found');
        return;
      }

      const discountCode = this.discountCode.textContent.trim();
      if (!discountCode) {
        console.warn('Discount code text is empty');
        return;
      }

      // Fallback: Check if clipboard API is available
      if (!navigator.clipboard || !navigator.clipboard.writeText) {
        console.warn('Clipboard API not available');
        if (typeof theme !== 'undefined' && theme.strings && theme.strings.discountCopyFail) {
          alert(theme.strings.discountCopyFail); // eslint-disable-line
        }
        return;
      }

      navigator.clipboard.writeText(discountCode).then(
        () => {
          // Success: Update button if it exists
          if (!this.discountCodeBtn) return;
          
          const successMarkup = this.copySuccess?.innerHTML || 
            (typeof theme !== 'undefined' && theme.strings && theme.strings.discountCodeCopied) || 
            'Copied';
          
          this.discountCodeBtn.classList.add('is-success');
          this.discountCodeBtn.innerHTML = successMarkup;

          window.setTimeout(() => {
            if (!this.discountCodeBtn) return;
            this.discountCodeBtn.classList.remove('is-success');
            this.discountCodeBtn.innerHTML = this.originalButtonHTML || '';
          }, 2000);
        },
        () => {
          // Error: Show fallback message
          const errorMessage = (typeof theme !== 'undefined' && theme.strings && theme.strings.discountCopyFail) || 
            'Could not copy code to clipboard. Your browser may not support this.';
          alert(errorMessage); // eslint-disable-line
        }
      );
    }
  }

  customElements.define('discount-code', DiscountCode);
}
